// Paleta de cores centralizada
const colors = {
    primary: "#2C3E50",        // Azul petróleo
    accent: "#E67E22",         // Laranja queimado
    cardBg: "#F4F6F8",         // Cinza neutro
    hover: "#eaf2f8",          // Hover sutil
    orcamento: "#3498DB",      // Azul para orçamentos
    bluePrimary: "#1976D2",    // Azul principal
  };
  
export default colors;
  